<template>
  <div :class="$style.workersn">
    <iframe
      :class="$style.customerIframe"
      name="customerIframe"
      ref="customerIframe"
      :src="workerSnUrl"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getTicket } from '@/api/customer';
import { getUserInfo } from '@/api/account';
import { channelType } from '@/config';

export default {
  name: '',
  data() {
    return {
      workerSnUrl: '',
    };
  },
  created() {
    document.title = '客服中心';
  },
  mounted() {
    this.handleUrl();
  },
  methods: {
    async handleUrl() {
      let workerSnUrl = this.getWorkerSnUrl();
      let userInfo = {};
      try {
        userInfo = await getUserInfo();
      } catch (error) {}
      userInfo = userInfo.data || {};
      workerSnUrl = `${workerSnUrl}?sdk_type=hm&open_id=${userInfo.open_id}&bind_state=${
        userInfo.game_user_id ? 1 : 2
      }&hm_id=${userInfo.id}`;
      this.workerSnUrl = workerSnUrl;
    },
    getWorkerSnUrl() {
      const isDev = process.env.NODE_ENV !== 'production';
      if (isDev) {
        if (channelType === 'channel_cw') {
          return '//192.168.2.219:9200/sdk/customer/customerHome';
        }
        return '//192.168.2.219:8090/v2/h5/customerHome';
      }
      if (channelType === 'channel_cw') {
        // 渠道3
        switch (window.location.hostname) {
          case 'hm.yxcgg63.com':
            return '//h5.yxcgg63.com/sdk/customer/customerHome';
          default:
            return '//h5.hnyuezan.com/sdk/customer/customerHome';
        }
      } else {
        switch (window.location.hostname) {
          case 'hm.680game.cn':
            return '//h5.680game.cn/v2/h5/customerHome';
          default:
            return `//h5.hzwxbz3.cn/v2/h5/customerHome`;
        }
      }
    },
    // 游戏子包名处理
    handleGameName(e) {
      try {
        let name = e.indexOf('(') == -1 ? e.split('（')[0] : e.split('(')[0];
        return name;
      } catch (error) {
        return '';
      }
    },
  },
};
</script>

<style lang="scss" module>
.workersn {
  width: 100%;
  height: 100%;
  .customerIframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
  }
}
</style>